import * as React from 'react'

const ShortRightArrow = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={17.984} viewBox="0 0 18 17.984" {...props}>
    <g id="Group_58376" data-name="Group 58376" transform="translate(0 0)">
      <path
        id="Union_29"
        data-name="Union 29"
        d="M8.99,17.982,0,8.993,8.992,0V3.6L4.911,7.677H18v2.632H4.912l4.08,4.08v3.6Z"
        transform="translate(18 17.984) rotate(180)"
        fill="CurrentColor"
      />
    </g>
  </svg>
)
export default ShortRightArrow
